<template>
  <section
    class="flex-col px-4 pt-8 pb-4 text-white bg-center bg-cover bg-sc-blue"
  >
    <div class="mt-16 text-center lg:items-center lg:text-left xl:flex lg:ml-28">
      <div>
        <div class="xl:w-8/12">
          <h2 class="text-3xl font-bold text-white md:text-5xl">
            {{ $t('message.tutorials.header') }}
          </h2>
          <p class="mb-5 lg:text-xl">
            {{ $t('message.tutorials.body') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
};
</script>
